import { HomeCategories } from './ui/HomeCategories.jsx'
import './ui/HomeCategories.scss'

export default HomeCategories
